import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface SidebarProps {
    isOpen: boolean;
    onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
    const { user } = useAuth();

    if (!user) return null;

    const organizerMenu = [
        {
            title: "Organizador",
            items: [
                {
                    name: 'Dashboard',
                    path: '/organizer/dashboard',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>
                },
                {
                    name: 'Perfil de Organizador',
                    path: '/organizer/business-details',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                },
            ]
        },
        {
            title: "Eventos",
            items: [
                {
                    name: 'Crear Evento',
                    path: '/organizer/events/create',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" /></svg>
                },
                {
                    name: 'Mis Eventos',
                    path: '/organizer/events',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                },
                {
                    name: 'Control de acceso',
                    path: '/organizer/access',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" /></svg>
                },
            ]
        },
        {
            title: "Pagos",
            items: [
                {
                    name: 'Pasarelas de Pago',
                    path: '/organizer/payment-gateways',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>
                },
                {
                    name: 'Órdenes en revisión',
                    path: '/organizer/orders/review',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7v2m0 4h.01" /></svg>
                },
                {
                    name: 'Liquidaciones',
                    path: '/organizer/settlements',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
                },
            ]
        },
        {
            title: "Estadísticas",
            items: [
                {
                    name: 'Ventas',
                    path: '/organizer/stats/sales',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
                },
                {
                    name: 'Cartera',
                    path: '/organizer/stats/wallet',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                },
            ]
        },
        {
            title: "Legal",
            items: [
                {
                    name: 'Términos y Condiciones',
                    path: '/terms',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                },
            ]
        },
        {
            title: "Soporte",
            items: [
                {
                    name: 'Contáctanos',
                    path: '/terms',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                },
            ]
        }
    ];

    const buyerMenu = [
        {
            title: "Personal",
            items: [
                {
                    name: 'Mis Tickets',
                    path: '/tickets',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" /></svg>
                },
                {
                    name: 'Mi Cuenta',
                    path: '/account',
                    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                }
            ]
        }
    ];

    const menuGroups = user.role === 'user-organizer' ? organizerMenu : buyerMenu;

    return (
        <>
            {/* 1. BACKDROP (Fondo oscuro) solo visible en móvil cuando isOpen es true */}
            <div
                className={`fixed inset-0 z-40 bg-black/50 transition-opacity md:hidden ${
                    isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                }`}
                onClick={onClose}
            />

            {/* 2. ASIDE (Contenedor Principal) */}
            <aside className={`
                fixed md:sticky top-0 md:top-20 
                h-full md:h-[calc(100vh-80px)] 
                w-64 bg-white border-r border-[var(--st-border)] 
                z-50 md:z-auto
                transition-transform duration-300 ease-in-out
                ${isOpen ? 'translate-x-0' : '-translate-x-full'} 
                md:translate-x-0 
                flex flex-col
            `}>

                {/* Header solo para móvil (Botón cerrar X) */}
                <div className="flex md:hidden items-center justify-between p-4 border-b border-[var(--st-border)]">
                    <span className="font-bold text-[var(--st-text-primary)]">Menú</span>
                    <button onClick={onClose} className="p-2 text-[var(--st-text-muted)] hover:text-[var(--st-error)]">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                </div>

                {/* Contenido Scrollable */}
                <div className="p-4 overflow-y-auto st-scrollbar flex-1">
                    {menuGroups.map((group, groupIndex) => (
                        <div key={groupIndex} className="mb-6">
                            <p className="px-4 text-xs font-semibold text-[var(--st-text-muted)] uppercase tracking-wider mb-2">
                                {group.title}
                            </p>
                            <nav className="space-y-1">
                                {group.items.map((link) => (
                                    <NavLink
                                        key={link.path}
                                        to={link.path}
                                        end
                                        onClick={onClose} // Cerrar menú al hacer clic en un link (UX móvil)
                                        className={({ isActive }) =>
                                            `st-nav-item ${isActive ? 'active' : ''}`
                                        }
                                    >
                                        {link.icon}
                                        {link.name}
                                    </NavLink>
                                ))}
                            </nav>
                        </div>
                    ))}
                </div>
            </aside>
        </>
    );
};

export default Sidebar;